<template lang="pug">
#admin_container.container-small
  h1#container_title 보도자료 관리
  .container_wr
    #s41.sub
      .inner
        .total_board_view_wrap.board_table 
          .tbl_view_head
            .tit
              h3 {{resData.title}}
            .info
              dl
                dt 등록일
                dd {{resData.update_time}}
                dt 조회수
                dt {{resData.views}}
          .fileLink(v-if="resData.fir_link !== null || resData.sec_link !== null")
            ul.info_file
            ol.info_link
              li(v-if="resData.fir_link !== null")
                a(:href='resData.fir_link' target='_black') {{resData.fir_link}}
              li.sec_link(v-if="resData.sec_link !== null")
                a(:href='resData.sec_link' target='_black') {{resData.sec_link}}
          .bo_v_con
            .content_area(v-html="resData.content")
          .view_btn
            div
              a(@click='$_goTo({name: "news-admin"})') 목록
              a(@click='$_goTo({name: "news-edit-admin", params: {id: param}, query: {nation: args.nation, cat: args.cat}})') 수정
              a(@click='delNews()') 삭제
              a.newb(@click='$_goTo({name: "news-write-admin"})') 새글쓰기
          .table-view-nav
            ul
              li(v-if='nextPrevList[0].idx !== 0')
                a.prev(@click='$_goTo({name: "news-detail-admin", params: {id: nextPrevList[0].idx}, query: {nation: args.nation }})')
                  em 이전글
                    img(:src='require("../../../assets/images/nextup.png")' alt='이전글')
                  span.nav-title.one-ico
                    span {{nextPrevList[0].title}}
              li(v-if='nextPrevList[1].idx !== 0')
                a.next(@click='$_goTo({name: "news-detail-admin", params: {id: nextPrevList[1].idx}, query: {nation: args.nation }})')
                  em 다음글
                    img(:src='require("../../../assets/images/prevdown.png")' alt='다음글')
                  span.nav-title.one-ico
                    span {{nextPrevList[1].title}}
</template>

<script>
export default {
  components: {},
  data() {
    return {
      args: {
        nation: this.$route.query.nation,
        cat: '',
      },
      param: this.$route.params.id,
      nextPrevList: [
        {
          idx: 0,
          name: '',
        },
        {
          idx: 0,
          name: '',
        },
      ],
      resData: {},
    };
  },
  computed: {},
  methods: {
    async getData() {
      await this.$_admin_get('admin/news/detail', {
        id: this.param,
        nation: this.args.nation,
      }).then(res => {
        if (res.status == 204) {
          alert('찾을 수 없는 게시물입니다.');
          this.$_goTo({ name: 'news-admin' });
          return;
        }
        this.resData = res.data.res[0];
        this.args.cat = res.data.res[0].category_num;
      });
    },
    async nextPrev() {
      await this.$_admin_get('admin/news/nextprev', {
        id: this.param,
        nation: this.args.nation,
      })
        .then(res => {
          this.nextPrevList = res.data.res;
        })
        .catch(() => {});
    },
    async delNews() {
      let checkedParam = {
        id: this.param,
        nation: this.args.nation,
      };
      await this.$_axios('PUT', 'admin/news/del', checkedParam).then(() => {
        alert('해당 글이 삭제되었습니다.');
        this.$_goTo({ name: 'news-admin' });
      });
    },
  },
  beforeMount() {
    this.args.nation = this.$route.query.nation;
  },
  mounted() {
    this.getData();
    this.nextPrev();
  },
  created() {},
};
</script>

<style scoped>
@import '../../../assets/css/news_board.css';

.tit h3 {
  font-size: 1em;
}
.board_list {
  clear: both;
  width: 100%;
  margin: 16px 0;
  border-top: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
  border-top: 2px solid #1f1f1f;
}
.board_list th {
  background: #fafafa;
  font-weight: normal;
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  height: 46px;
  color: #333;
}
.board_list td.subject {
  text-align: left;
}
.board_list td.subject a {
  margin-left: 20px;
}
.board_list td {
  border-bottom: 1px solid #eee;
  height: 40px;
  text-align: center;
}
table td {
  line-height: 22px;
}
#s41.sub {
  padding: 0;
  /* padding-top: 30px; */
}
.info dt,
.info dd {
  font-size: 14px;
}

.edit_btn {
  margin-top: 50px;
}
.board_button {
  clear: both;
  text-align: right;
  margin-bottom: 10px;
}
.board_button a {
  font-size: 13px;
  display: inline-block;
  padding: 10px 25px;
  border: 1px solid #ddd;
  line-height: 100%;
  margin-left: 5px;
  background: #fff;
}
.board_button a.newb {
  background: #2c2c2c;
  color: #fff;
  cursor: pointer;
}
em img {
  margin-right: 13px;
}
.list_img {
  margin-top: 10px;
}
.list_td {
  border-right: 1px solid #e8e8e8;
}
.view_btn {
  margin-top: 15px;
}
.prev em,
.next em {
  display: flex;
}
.info_link li a {
  word-break: break-all;
}
</style>
